exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reader-actions-mobile{box-shadow:0 0 10px 0 rgba(118,136,154,.16);width:100%;height:100%;background:#f5f7f7;border-radius:4px 4px 0 0;display:flex;justify-content:center}.reader-actions-mobile__container{max-width:464px;display:flex;justify-content:space-between;align-items:center}.reader-actions-mobile__icon-container{display:flex;flex-direction:column;margin-right:16px;margin-left:16px}.reader-actions-mobile__icon-label{font-size:8px;line-height:16px;font-weight:inherit;margin:0 auto}.reader-actions-mobile__icon-label--disabled{color:#c0c8cc}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};